// Aggregate station status across the members of a multipanel group.
//
// Returns:
//   {
//     status: "" | "working" | "ready",
//     stations: [
//       { name, total, ready, working, waiting, rollup }  // rollup ∈ "", "working", "ready"
//     ]
//   }
//
// `total` excludes members whose station status is "disabled" (a member that
// does not pass through this station should not count toward the aggregate).
export function aggregateGroupStatus(group, assembliesByUuid, pl_stations) {
    const members = (group?.memberships || [])
        .map(m => assembliesByUuid.get(m.assembly))
        .filter(Boolean)
    const stations = (pl_stations || []).map(s => {
        const name = s?.name || "unknown"
        let total = 0, ready = 0, working = 0, waiting = 0
        for (const a of members) {
            const st = a?.stations_status?.[name]
            if (st === "disabled") continue
            total++
            if (st === "ready") ready++
            else if (st === "working") working++
            else waiting++
        }
        let rollup = ""
        if (total > 0 && ready === total) rollup = "ready"
        else if (total > 0 && (ready > 0 || working > 0)) rollup = "working"
        return { name, total, ready, working, waiting, rollup }
    })
    const active = stations.filter(s => s.total > 0)
    let status = ""
    if (active.length && active.every(s => s.rollup === "ready")) status = "ready"
    else if (active.some(s => s.rollup === "working" || s.rollup === "ready")) status = "working"
    return { status, stations }
}
